import SignupService from "@/store/services/signup.service.js"

export default {
  namespaced: true,
  state: {
    userCountry: '',
    userLanguage: '',
    supportedCountries: ['NL', 'ES', 'BE'],
    languageOptions: [
      { value: 'en', text: 'English'},
      { value: 'nl', text: 'Nederlands'},
      { value: 'es', text: 'Español'}
    ],
    newSignup: false,
    signupType: 'normal'
  },
  getters: {
    getUserCountry: state => state.userCountry,
    getUserLanguage: state => state.userLanguage,
    getSupportedCountries: state => state.supportedCountries,
    getLanguageOptions: state => state.languageOptions,
    getSignupStatus: state => state.newSignup,
    getSignupType: state => state.signupType,
  },
  mutations: {
    SET_USER_COUNTRY (state, country) {
      state.userCountry = country
    },
    SET_USER_LANGUAGE (state, language) {
      state.userLanguage = language
    },
    SET_NEW_SIGNUP (state) {
      state.newSignup = true
    },
    SET_SIGNUP_TYPE (state, type) {
      state.signupType = type
    }
  },
  actions: {
    checkAvailability (_, email) {
      return SignupService.checkAvailability({ email: email }).then((response) => {
        return response
      })
    },
    checkHeroCode (_, code) {
      return SignupService.checkHeroCode({ referral_code: code }).then((response) => {
        return response
      })
    },
    signUp ({ commit }, payload) {
      return SignupService.signUp(payload).then((response) => {
        commit('SET_NEW_SIGNUP')
        commit('SET_SIGNUP_TYPE', 'normal')
        return response
      })
    },
    signUpHeroes ({ commit }, payload) {
      return SignupService.signUpHeroes(payload.data, payload.invite_code).then((response) => {
        commit('SET_NEW_SIGNUP')
        commit('SET_SIGNUP_TYPE', 'normal')
        return response
      })
    },
    signUpAccountants ({ commit }, payload) {
      return SignupService.signUpAccountants(payload).then((response) => {
        commit('SET_NEW_SIGNUP')
        commit('SET_SIGNUP_TYPE', 'accountants')
        return response
      })
    },
    async geoLocateUserIp ({ commit, dispatch, getters }) {
      if (getters.getUserCountry === '') {
        try {
          const response = await fetch('https://ipinfo.io/json')
          const data = await response.json()
          let country = 'NL'
          if (data.country && data.country !== '') {
            country = data.country
            // ip localized, try to set default language for that country
            const selLanguage = getters.getLanguageOptions.find(item => item.value === country.toLowerCase())
            if (selLanguage) {
              commit('SET_USER_LANGUAGE', selLanguage.value)
            }
          }
          dispatch('setUserCountry', country)
        } catch (error) {
          console.error('Error fetching IP information:', error)
          // Handle the error if needed
        }
      }
    },
    setUserCountry ({ commit }, country) {
      commit('SET_USER_COUNTRY', country)
  
      const cname = 'gk_country'
      const cvalue = country
      const exdays = 365
  
      const d = new Date()
      d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000))
      const expires = 'expires=' + d.toUTCString()
      document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/'
    }
  }
}
